import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Provider } from 'react-redux';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { store } from './store';
import PrivateRoute from './components/auth/PrivateRoute';
import MainLayout from './layouts/MainLayout';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import Profile from './pages/Profile';
import Settings from './pages/Settings';
import TableList from './pages/TableList';
import TableView from './pages/TableView';
import TableCreate from './pages/TableCreate';
import TableEdit from './pages/TableEdit';
import TablePermissions from './pages/TablePermissions';
import TableDataForm from './pages/TableDataForm';
import TableDataView from './pages/TableDataView';
import TableDataHistory from './pages/TableDataHistory';
import TransferList from './pages/TransferList';
import TransferCreate from './pages/TransferCreate';
import TransferView from './pages/TransferView';
import UserList from './pages/UserList';
import UserCreate from './pages/UserCreate';
import UserEdit from './pages/UserEdit';
import AuditLog from './pages/AuditLog';
import NotFound from './pages/NotFound';

// Создаем тему
const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontSize: 14,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightBold: 700,
  },
});

function App() {
  return (
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <CssBaseline />
          <BrowserRouter>
            <Routes>
              {/* Публичные маршруты */}
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              
              {/* Защищенные маршруты */}
              <Route path="/" element={<PrivateRoute element={<MainLayout />} />}>
                <Route index element={<Navigate to="/dashboard" replace />} />
                <Route path="dashboard" element={<Dashboard />} />
                <Route path="profile" element={<Profile />} />
                <Route path="settings" element={<Settings />} />
                
                {/* Таблицы */}
                <Route path="tables">
                  <Route index element={<TableList />} />
                  <Route path="create" element={<TableCreate />} />
                  <Route path=":id" element={<TableView />} />
                  <Route path=":id/edit" element={< TableEdit />} /> 
                  <Route path=":id/permissions" element={<TablePermissions />} />
                  <Route path=":id/data/create" element={< TableDataForm/>} />
                  <Route path=":id/data/:dataId" element={< TableDataView/>} /> 
                  <Route path=":id/data/:dataId/edit" element={<TableDataForm />} /> 
                  <Route path=":id/data/:dataId/history" element={<TableDataHistory />} />
                </Route>
                
                {/* Передачи данных */}
                <Route path="transfers">
                  <Route index element={<TransferList />} />
                  <Route path="create" element={<TransferCreate />} />
                  <Route path=":id" element={<TransferView />} />
                </Route>
                
                {/* Пользователи (только для администраторов) */}
                <Route path="users">
                  <Route index element={< UserList />} /> 
                  <Route path="create" element={< UserCreate/>} />
                  <Route path=":id" element={< UserEdit/>} /> 
                </Route>
                
                {/* Аудит (только для администраторов) */}
                <Route path="audit" element={< AuditLog />} /> 
              </Route>
              
              {/* 404 Not Found */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </BrowserRouter>
        </LocalizationProvider>
      </ThemeProvider>
    </Provider>
  );
}

export default App;